<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4EnZCg/tc-custom/FC-9781528993036.jpg?1684515369589?1709061606734" alt="This image is the cover for the book System Reset"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">System Reset
      </h1>
      <p class="bookDescription body article font2">
        <p>Earth has changed. Warped by an oppressive ruler, all life segregated to societies encased within the ‘New State’ of the Earth. Detective Sartore struggles with constant change and a rising Japanese crime syndicate in the New State’s Manhattan sector. Galaxies away, two ex-demolition operatives are rehired by a planetary corporation to investigate a small unprotected system containing New Earth. An Earth tribe, exiled to purify the planet known as Mars, develops a weapon to avenge their home planet and bring death to its tyrannical alien king. All is affected, all is connected. Nothing is as it seems.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe Clements
      </h2>
      
      <p class="authorDescription body article">A varied and adaptable writer, Joe Clements made his first splash in the world of literature in Flash Fiction Magazine with his intense psychological short, Modern Medicine. Since then he has developed several fictional universes, one of which playing host to his condensed sci-fi epic, System Reset. Clements’ dynamic and versatile style is influenced by everything from classic literature and poetry to films, video games, death metal music and even a deep interest in neuroscience and philosophy. A man of emotion, he is eager to invoke a plethora of which within the bleak, extreme and disconcerting.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75b35796